class GiftLoveUpsellPopup extends CoreElement {
  static get observedAttributes() {
    return ['title', 'description', 'products'];
  }

  constructor() {
    super();
    console.log('Constructor innerHTML:', this.innerHTML);
    this.state = {
      title: '',
      description: '',
      products: []
    };
  }

  connectedCallback() {
    const trimmedContent = this.innerHTML.trim();
    try {
      const products = JSON.parse(trimmedContent);
      this.setState({ products });
    } catch (e) {
      console.error('Error parsing innerHTML:', e);
      console.log('Failed content:', trimmedContent);
    }
  }

  attributeChangedCallback(name, oldValue, newValue) {
    if (name === 'products') {
      try {
        const products = JSON.parse(newValue);
        this.setState({ products });
      } catch (e) {
        console.error('Invalid products data:', e);
      }
    } else {
      this.setState({ [name]: newValue });
      console.log(`${name} changed:`, newValue);
    }
  }

  formatPrice = (price) => {
    return `£${(price / 100).toFixed(2)}`;
  }

  renderHTML = () => {
    const { title, description, products } = this.state;
    console.log('Products:', products);
    
    // Check if this is the gift card popup by looking at the first product
    const isGiftCardPopup = products.length > 0 && products[0].isGiftCard;
    
    // Prepare the bottom navigation links based on popup type
    const mobileNavLinks = isGiftCardPopup 
      ? `<a href="#" class="continue-shopping">No card, thanks</a>`
      : `<a href="#" class="continue-shopping">Back to website</a>
         <a href="/cart" class="checkout-button">Checkout</a>`;
         
    const desktopNavLinks = isGiftCardPopup
      ? `<a href="#" class="continue-shopping">No card, thanks</a>`
      : `<a href="#" class="continue-shopping">Back to website</a>
         <a href="/cart" class="checkout-button">Checkout</a>`;
    
    const html = `
            ${this.renderStyle()}
            <div class="popup-container">
                <button class="close-button">×</button>
                <div class="mobile-continue-shopping">
                  ${mobileNavLinks}
                </div>
                <h2 class="title">${title || ''}</h2>
                <p class="description">${description || ''}</p>
                
                <div class="products-container">
                    <button class="scroll-button prev">‹</button>
                    <div class="products-grid">
                        ${products.map(product => `
                            <div class="product-item-container">
                                <a class="product-item">
                                    <img src="${product.image}" alt="${product.title}">
                                    <h3>${product.title}</h3>
                                    <p class="price">${this.formatPrice(product.price)}</p>
                                </a>
                                ${product.isAdded ? `
                                    <div class="gift-love-button-added">
                                        <p>ADDED <span class="checkmark">✓</span></p>
                                    </div>
                                ` : `
                                    <div class="gift-love-button" data-product-id="${product.id}" data-variant-id="${product.variantId}" data-url="${product.url}" data-is-personalised="${product.isPersonalised}">
                                        <p class="button-text">${product.isPersonalised ? 'PERSONALISE' : 'ADD'}</p>
                                        <p class="loading-text">ADDING<span class="dots">...</span></p>
                                    </div>
                                `}
                            </div>
                        `).join('')}
                    </div>
                    <button class="scroll-button next">›</button>
                </div>
                <div class="desktop-continue-shopping">
                  ${desktopNavLinks}
                </div>
            </div>
        `;

    this.shadow.innerHTML = html;
    
    // Add event listeners
    this.shadow.querySelector('.close-button').addEventListener('click', () => {
        this.remove();
    });
    if (window.innerWidth > 767) {
        const productsGrid = this.shadow.querySelector('.products-grid');
        const prevButton = this.shadow.querySelector('.scroll-button.prev');
        const nextButton = this.shadow.querySelector('.scroll-button.next');

        const scrollAmount = 246 + 30; // item width + gap
        
        prevButton.addEventListener('click', () => {
            productsGrid.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
        });

        nextButton.addEventListener('click', () => {
            productsGrid.scrollBy({ left: scrollAmount, behavior: 'smooth' });
        });

        // Update button states on scroll
        const updateButtons = () => {
            prevButton.disabled = productsGrid.scrollLeft <= 0;
            nextButton.disabled = productsGrid.scrollLeft >= productsGrid.scrollWidth - productsGrid.clientWidth;
        };

        productsGrid.addEventListener('scroll', updateButtons);
        updateButtons(); // Initial state
    }

    const addButtons = this.shadow.querySelectorAll('.gift-love-button');
    addButtons.forEach(button => {
      button.onclick = (event) => {
        if (this.onClickProduct) {
          button.classList.add('adding');
          this.onClickProduct({
            ...button.dataset,
            button: button
          });
        }
      }
    });

    this.shadow.querySelectorAll('.continue-shopping').forEach(el => {
      el.addEventListener('click', (e) => {
        e.preventDefault();
        this.remove();
      });
    });
    
    this.shadow.querySelectorAll('.checkout-button').forEach(el => {
      el.addEventListener('click', (e) => {
        // No preventDefault here to allow natural navigation to cart
        this.remove();
      });
    });
  }

  markProductAsAdded = (productId) => {
    console.log('markProductAsAdded', productId);
    const { products } = this.state;
    
    const numProductId = Number(productId);
    
    const product = products.find(product => Number(product.id) === numProductId);
    
    if (product) {
      console.log(`Marking product ${numProductId} as added`);
      product.isAdded = true;
      this.setState({ products });
    } else {
      console.warn(`Product with ID ${numProductId} not found in this popup's products`);
    }
  }

  renderStyle = () => {
    return `
            <style>
              @import url('${this.getAttribute('css') || 'gift-love-upsell-popup.css'}');
              :host {
                  position: fixed;
                  top: 0;
                  left: 0;
                  width: 100%;
                  height: 100%;
                  display: flex;
                  justify-content: center;
                  align-items: center;
                  z-index: 999;
                  background-color: rgba(0, 0, 0, 0.62); /* Overlay với độ mờ 62% */
              }

              .continue-shopping {
                  display: inline-block;
                  text-align: center;
                  font-size: 20px;
                  color: #000;
                  text-decoration: underline;
                  cursor: pointer;
                  margin: 0 15px;
              }
              
              .checkout-button {
                  display: inline-block;
                  text-align: center;
                  font-size: 20px;
                  color: #000;
                  text-decoration: underline;
                  cursor: pointer;
                  margin: 0 15px;
              }

              .mobile-continue-shopping {
                  display: none;
                  margin-top: 20px;
                  text-align: center;
              }

              .desktop-continue-shopping {
                margin: 0 auto;
                margin-top: 40px;
                text-align: center;
                width: 80%;
                display: flex;
                justify-content: space-around;
              }

              @media (max-width: 767px) {
                  .mobile-continue-shopping {
                      display: block;
                  }
                  .desktop-continue-shopping {
                      display: none;
                  }
                  
                  .scroll-button {
                      display: none !important;
                      visibility: hidden !important;
                      opacity: 0 !important;
                      pointer-events: none !important;
                  }
                  
                  .continue-shopping, .checkout-button {
                      font-size: 16px;
                      margin: 0 10px;
                  }
              }

              .gift-love-button {
                  position: relative;
              }

              .gift-love-button.adding {
                  opacity: 0.7;
                  pointer-events: none;
              }

              .gift-love-button .loading-text {
                  display: none;
              }

              .gift-love-button.adding .button-text {
                  display: none;
              }

              .gift-love-button.adding .loading-text {
                  display: block;
              }

              .loading-text .dots {
                  display: inline-block;
                  animation: dotAnimation 1.5s infinite;
              }

              @keyframes dotAnimation {
                  0% { content: ''; }
                  25% { content: '.'; }
                  50% { content: '..'; }
                  75% { content: '...'; }
                  100% { content: ''; }
              }

              .gift-love-button-added {
                  animation: fadeIn 0.3s ease-in;
              }

              @keyframes fadeIn {
                  from { opacity: 0; }
                  to { opacity: 1; }
              }

              .scroll-button {
                  -webkit-appearance: none;
                  -webkit-transform: translateY(-50%);
                  min-width: 40px;
                  min-height: 40px;
                  width: 40px !important;
                  height: 40px !important;
                  padding: 0;
                  line-height: 40px;
                  box-sizing: border-box;
              }

              @supports (-webkit-touch-callout: none) {
                  .scroll-button {
                      border-radius: 50%;
                      display: flex !important;
                      align-items: center !important;
                      justify-content: center !important;
                  }
              }
            </style>
        `;
  }
}

customElements.define('gift-love-upsell-popup', GiftLoveUpsellPopup);
